module.exports = __webpack_public_path__ + "img/suggestion-page.cc030b0a.jpg";